import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { ReasonsDialogComponent } from './reasons-dialog/reasons-dialog.component';
import { MetricValueCommentType } from '../../../generated/graphql';

export interface ReasonChipsData extends MetricValueCommentType {
  multiplier: number;
  reasonGroup: MetricValueCommentType[];
}

@Component({
  selector: 'app-reason-with-comment',
  templateUrl: './reason-with-comment.component.html',
  styleUrls: ['./reason-with-comment.component.scss']
})
export class ReasonWithCommentComponent implements OnDestroy {
  subscription = new Subscription();
  needUpdate = new EventEmitter<boolean>();
  isUpdateNeeded = false;

  @Input() reason: ReasonChipsData;
  @Input() managerName: string;
  @Input() metricValueCandidate: { firstName: string, lastName: string, livasId: number, employeeLivasId: number, country?: any };
  @Input() metricValueClient: { name: string, id: string, livasId: number, country?: any };
  @Input() metricGroup: string;
  @Input() metricGroupId: string;

  @Output() updateCommentsValue: EventEmitter<any> = new EventEmitter();
  @Output() updateTableData: EventEmitter<any> = new EventEmitter();

  constructor(
    private dialog: MatDialog
  ) {
    this.subscription.add(this.needUpdate.subscribe(() => this.isUpdateNeeded = true));
  }

  getFullComment(set: MetricValueCommentType[]): string {
    return set.map(reason => reason.comment).join(' | ');
  }

  openReasonDialog() {
    const dialog = this.dialog.open(ReasonsDialogComponent, {
      data: {
        reasonSet: this.reason.reasonGroup,
        managerName: this.managerName,
        metricGroup: this.metricGroup,
        metricGroupId: this.metricGroupId,
        metricValueCandidate: (this.metricValueCandidate.firstName || this.metricValueCandidate.lastName) ? this.metricValueCandidate : null,
        metricValueClient: this.metricValueClient.name ? this.metricValueClient : null,
        needUpdate: this.needUpdate
      },
      autoFocus: false
    });

    dialog.afterClosed().subscribe(v => {
      // if (this.isUpdateNeeded) {
      //   this.updateCommentsValue.emit();
      // }
      this.updateTableData.emit(v);
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
